//auth Action Types
// Create
export const TRANSACTION_CREATION_STARTED = "TRANSACTION_CREATION_STARTED";
export const TRANSACTION_CREATION_SUCCES = "TRANSACTION_CREATION_SUCCES";
export const TRANSACTION_CREATION_FAIL = "TRANSACTION_CREATION_FAIL";

//Fetch
export const TRANSACTION_FETCH_STARTED = "TRANSACTION_FETCH_STARTED";
export const TRANSACTION_FETCH_SUCCES = "TRANSACTION_FETCH_SUCCES";
export const TRANSACTION_FETCH_FAIL = "TRANSACTION_FETCH_FAIL";

//Update
export const TRANSACTION_UPDATE_STARTED = "TRANSACTION_UPDATE_STARTED";
export const TRANSACTION_UPDATE_SUCCES = "TRANSACTION_UPDATE_SUCCES";
export const TRANSACTION_UPDATE_FAIL = "TRANSACTION_UPDATE_FAIL";

//Delete
export const TRANSACTION_DELETE_STARTED = "TRANSACTION_DELETE_STARTED";
export const TRANSACTION_DELETE_SUCCES = "TRANSACTION_DELETE_SUCCES";
export const TRANSACTION_DELETE_FAIL = "TRANSACTION_DELETE_FAIL";
